export default __webpack_public_path__ + "static/media/sip_info_icon.a9bf960d.svg";